/***********************/
/* Angular + external */
import { Component, Injector } from "@angular/core";
// models
import { ICDAutocompleteModel } from "../../data-idc/controls/icd-autocomplete.model";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ICDBase, ICD_BASE_DEFAULT_HOST_RECORD } from "./icd-base.component";
import { ATDLInterfaceControlModel } from "../../data-atdl/model/atdl-interface-control.model";
import { ICNInputControlState } from "../controls/models/bfx-interface-controls.enums";
import { ICDNResponseCommand } from "../../data-idc/enums/icd-response-cmd.enum";

@Component({
  selector: "icd-unsupported",
  host: {
    "[class.icd__unsupported__container]": "true",
    ...ICD_BASE_DEFAULT_HOST_RECORD,
  },
  templateUrl: "./html/icd-unsupported.html",
  standalone: false,
})
export class ICDUnsupportedComponent extends ICDBase<ICDAutocompleteModel> {
  /**********************************************************************/
  /* DATA */

  public subData: any = {};

  public note: string = "Unsupported Interface Component";
  /************************************/
  onModelChange: Function = () => {};
  onModelTouched: Function = () => {};

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor(public injector: Injector) {
    super(injector);
    this.oeLogger = this.oeLogger.for(__dirname);
    this.initialize();
  }

  /**********************************************************************/
  /* INITIALIZE */

  protected initialize(): void {
    super.initialize();
    this.label = "Unsupported";
  }

  /**********************************************************************/
  /* DYNAMIC CONTROL API  */

  protected initializeICDSpecificModelProperties(): boolean {
    let error: boolean = false;
    if (this.model instanceof ATDLInterfaceControlModel) {
      if (typeof this.model.label === "string" && this.model.label.length > 0) {
        this.label = `[${this.model.icdTypeText}] ` + this.model.label;
      } else {
        this.label = `[${this.model.icdTypeText}] ` + "No label";
      }
      this.validateIC();
    } else {
      error = true;
    }
    return error;
  }

  /**********************************************************************/
  /* DYNAMIC CONTROL - no */

  protected handleConstraintUpdate(data: any): void {}

  /**********************************************************************/
  /* ControlValueAccessor */

  writeValue(value: any): void {
    this.data.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  /**********************************************************************/
  /* EVENTS */

  public onFocus(event: any): void {}

  public onBlur(event: any): void {}

  public onChange(event: any): void {}

  public onSelect(event: any): void {}

  /**********************************************************************/
  /* EXTERNAL API */

  public focusInput() {}

  public setDefault() {}

  protected setAndUpdateValue(value: any): void {}

  public updateValue(): void {}

  public resetIC(): void {}

  public load(value: any, propagate?: boolean): void {
    this.dynRespond(ICDNResponseCommand.LOAD_COMPLETE);
  }

  public set(value: any): void {}

  private compose(): void {}

  public validateIC(): boolean {
    if (this.required) {
      this.data.state = ICNInputControlState.INVALID;
      this.data.errorMsg = `${this.label} is unsupported but required, strategy can not be submitted.`;
      return false;
    } else {
      this.data.state = ICNInputControlState.VALID;
      this.data.errorMsg = "";
      return true;
    }
  }
}
